var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDevKeeb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "386.000000pt",
    height: "386.000000pt",
    viewBox: "0 0 386.000000 386.000000",
    preserveAspectRatio: "xMidYMid meet",
    id: "svg50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m 2256,3375 c -1504,323.3333 -752,161.6667 0,0 z",
    id: "path44",
    style: {
      fill: "#b93a97",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 45.1,3.3 c -1.8,0.6 -5.7,3.2 -8.6,5.9 -9.5,8.7 -9,3.7 -9,85.8 0,56.6 0.3,72.3 1.3,75.2 2,5.6 9.3,13.2 15.2,15.7 5,2.1 6.1,2.2 37.3,1.9 30.8,-0.3 32.4,-0.4 36.2,-2.5 5.3,-2.8 9.9,-7.8 12.4,-13.3 1.7,-3.7 2.1,-6.6 2.1,-17 V 142.5 L 110.3,120.8 88.5,99 110.3,77.2 C 129.5,58 132,55.1 132,52.3 132,49 129.1,46 126.1,46 125.3,46 113.2,57.4 99.3,71.2 79.5,90.9 74,97 74,99 c 0,2 5.1,7.6 23,25.5 l 23,23 v 9.1 c 0,7.8 -0.3,9.6 -2.3,12.5 -4.4,6.6 -5.8,6.9 -38.3,6.9 -28.5,0 -29.2,0 -32.4,-2.3 -1.9,-1.2 -4.3,-3.8 -5.4,-5.7 -2.1,-3.4 -2.1,-4.7 -2.1,-73.7 0,-69.6 0,-70.2 2.1,-73 1.1,-1.5 3.6,-3.8 5.4,-5.1 L 50.3,14 H 193 335.7 l 3.3,2.2 c 1.8,1.3 4.3,3.6 5.4,5.1 2.1,2.8 2.1,3.4 2.1,73.7 0,70.3 0,70.9 -2.1,73.7 -1.1,1.5 -3.6,3.8 -5.4,5.1 l -3.3,2.2 h -62.2 c -70.3,0 -69.2,-0.1 -77.2,7.3 -7.1,6.5 -8.6,10.4 -9.1,22.9 L 186.8,217 H 101 c -58.3,0 -86.8,0.3 -88.7,1.1 -3.8,1.4 -8.3,5.7 -9.9,9.6 -1.1,2.6 -1.4,16.1 -1.4,73.7 0,47.4 0.3,71.4 1.1,73.3 1.4,3.8 5.7,8.3 9.6,9.9 2.7,1.2 32.3,1.4 181.2,1.4 123.3,0 178.8,-0.3 180.8,-1.1 3.4,-1.3 8,-5.5 9.9,-9.1 2.1,-4 2.1,-144.6 0,-148.6 -1.9,-3.6 -6.5,-7.8 -9.9,-9.1 -1.9,-0.8 -30.5,-1.1 -88.9,-1.1 h -86 l 0.4,-9.4 c 0.3,-10.2 1.4,-12.7 7.2,-17 2.7,-2.1 4.1,-2.1 67.9,-2.6 64.6,-0.5 65.2,-0.5 69.3,-2.7 2.2,-1.2 5.7,-4 7.8,-6.3 7.5,-8.4 7.1,-3.2 7.1,-83.5 0,-67.2 -0.1,-72.3 -1.8,-76.7 C 354.4,13 345.9,4.9 340.3,3.2 334.9,1.6 50.2,1.7 45.1,3.3 Z m 326.1,227.4 c 1.7,1.5 1.8,5 1.8,70.6 0,62.8 -0.1,69.2 -1.7,70.9 -1.5,1.7 -8.4,1.8 -178.1,1.8 -162.9,0 -176.7,-0.1 -178.4,-1.7 -1.7,-1.5 -1.8,-5 -1.8,-70.6 0,-62.8 0.1,-69.2 1.7,-70.9 1.5,-1.7 8.4,-1.8 178.1,-1.8 162.9,0 176.7,0.1 178.4,1.7 z",
    id: "path2-5",
    style: {
      fill: "#b93a97",
      fillOpacity: 1,
      strokeWidth: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 32,258 c -2.5,2.5 -2.6,6.2 -0.1,8.4 1.5,1.3 3.4,1.6 9.2,1.4 6.8,-0.3 7.4,-0.5 8.8,-3 1.4,-2.5 1.4,-2.9 -0.5,-5.5 -1.9,-2.5 -2.8,-2.8 -8.7,-3.1 -5.6,-0.2 -6.9,0 -8.7,1.8 z",
    id: "path4-5",
    style: {
      fill: "#b93a97",
      fillOpacity: 1,
      strokeWidth: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 69.2,257.6 c -2.6,1.8 -3,6.5 -0.6,8.8 2.1,2.1 22,2.3 24.8,0.3 2.4,-1.7 2.4,-6.2 0.1,-8.7 -1.6,-1.7 -3.1,-2 -11.9,-2 -7.6,0 -10.7,0.4 -12.4,1.6 z",
    id: "path6-7",
    style: {
      fill: "#b93a97",
      fillOpacity: 1,
      strokeWidth: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 113.1,258.7 c -2.3,2.8 -2,5.9 0.7,8 1,0.9 5.2,1.3 12.2,1.3 11.8,0 14,-1 14,-6.3 0,-4.5 -3.2,-5.7 -14.6,-5.7 -9.9,0 -10.3,0.1 -12.3,2.7 z",
    id: "path8-8",
    style: {
      fill: "#b93a97",
      fillOpacity: 1,
      strokeWidth: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 158,258 c -2.4,2.4 -2.5,4.8 -0.4,7.8 1.4,2.1 2.3,2.2 12.8,2.2 9.7,0 11.5,-0.3 12.9,-1.8 2.3,-2.5 2.1,-5.8 -0.3,-8.2 -1.7,-1.7 -3.3,-2 -12.5,-2 -9.2,0 -10.8,0.3 -12.5,2 z",
    id: "path10-3",
    style: {
      fill: "#b93a97",
      fillOpacity: 1,
      strokeWidth: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 203,258 c -2.5,2.5 -2.6,6.2 -0.2,8.3 1.5,1.4 4,1.7 13,1.7 10.3,0 11.2,-0.2 12.6,-2.2 2.1,-3 2,-5.4 -0.4,-7.8 -1.7,-1.7 -3.3,-2 -12.5,-2 -9.2,0 -10.8,0.3 -12.5,2 z",
    id: "path12-1",
    style: {
      fill: "#b93a97",
      fillOpacity: 1,
      strokeWidth: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 248.2,257.6 c -2.7,1.9 -2.9,6.4 -0.4,8.7 1.5,1.4 4,1.7 12.5,1.7 9.4,0 10.9,-0.2 12.7,-2 2.5,-2.5 2.5,-4.1 -0.1,-7.4 -2,-2.5 -2.4,-2.6 -12.3,-2.6 -7.6,0 -10.7,0.4 -12.4,1.6 z",
    id: "path14-5",
    style: {
      fill: "#b93a97",
      fillOpacity: 1,
      strokeWidth: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 293.2,257.6 c -2.9,2 -3.1,7.9 -0.3,9.4 1.1,0.5 6.7,1 12.5,1 11.6,0 13.6,-0.9 13.6,-6 0,-4.7 -3,-6 -14,-6 -7,0 -10.1,0.4 -11.8,1.6 z",
    id: "path16-5",
    style: {
      fill: "#b93a97",
      fillOpacity: 1,
      strokeWidth: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 337.1,258.6 c -2.6,3.3 -2.6,4.9 -0.1,7.4 1.6,1.6 3.3,2 8.8,2 7.7,0 10.2,-1.6 10.2,-6.3 0,-3.9 -3.4,-5.7 -10.6,-5.7 -5.6,0 -6.5,0.3 -8.3,2.6 z",
    id: "path18-9",
    style: {
      fill: "#b93a97",
      fillOpacity: 1,
      strokeWidth: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 33.3,296 c -2.5,1 -3.8,4.8 -2.9,7.8 1,3 5.8,4.5 13.2,4 5.5,-0.3 7,-0.8 8.5,-2.7 2.5,-3.1 2.4,-4.7 -0.6,-7.6 -2.1,-2.2 -3.3,-2.5 -9.2,-2.4 -3.7,0 -7.8,0.4 -9,0.9 z",
    id: "path20-4",
    style: {
      fill: "#b93a97",
      fillOpacity: 1,
      strokeWidth: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 71.5,297.4 c -3,3 -3.1,4.6 -0.6,7.7 1.9,2.3 2.4,2.4 17.1,2.4 13.9,0 15.3,-0.2 16.6,-1.9 1.8,-2.5 1.8,-5.7 0,-8.2 -1.3,-1.7 -2.9,-1.9 -16,-2.2 -14.4,-0.3 -14.6,-0.3 -17.1,2.2 z",
    id: "path22-4",
    style: {
      fill: "#b93a97",
      fillOpacity: 1,
      strokeWidth: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 124.6,297.1 c -1.5,1.2 -2.6,3 -2.6,4.4 0,1.4 1.1,3.2 2.6,4.4 2.4,1.9 4,2.1 15.3,2.1 14,0 17,-0.9 18.6,-5.4 0.8,-2.5 0.6,-3.1 -1.8,-5.2 -2.7,-2.3 -3.5,-2.4 -16.1,-2.4 -12,0 -13.6,0.2 -16,2.1 z",
    id: "path24-2",
    style: {
      fill: "#b93a97",
      fillOpacity: 1,
      strokeWidth: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 178,296.3 c -2,1 -2.5,2 -2.5,5.2 0,5.7 2.2,6.5 17.5,6.5 14.9,0 17.4,-0.9 17.8,-6.2 0.5,-5.9 -1.8,-6.8 -17.3,-6.8 -8.5,0 -13.9,0.5 -15.5,1.3 z",
    id: "path26-9",
    style: {
      fill: "#b93a97",
      fillOpacity: 1,
      strokeWidth: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 229.5,297.5 c -3,2.9 -3.1,4.5 -0.6,7.6 1.8,2.3 2.6,2.4 15.8,2.7 12.9,0.3 14,0.2 16.6,-1.8 1.5,-1.2 2.7,-3.1 2.7,-4.3 -0.1,-5.5 -3.4,-6.7 -19,-6.7 -12.6,0 -13.2,0.1 -15.5,2.5 z",
    id: "path28-4",
    style: {
      fill: "#b93a97",
      fillOpacity: 1,
      strokeWidth: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 283.3,296 c -2.7,1.1 -3.9,5.3 -2.5,8.5 1.5,3.2 5.1,3.8 20.2,3.3 11.4,-0.3 12.3,-0.5 14.1,-2.7 2.5,-3.1 2.4,-4.7 -0.6,-7.6 -2.3,-2.4 -2.9,-2.5 -15.7,-2.4 -7.3,0 -14.3,0.4 -15.5,0.9 z",
    id: "path30-0",
    style: {
      fill: "#b93a97",
      fillOpacity: 1,
      strokeWidth: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 334.4,297.5 c -2.7,2.7 -2.6,5.5 0.2,8.5 1.9,1.9 13.5,2.6 17.4,1 5,-2.1 5.3,-9.2 0.3,-11.1 -1.3,-0.5 -5.3,-0.9 -8.9,-0.9 -5.6,0 -6.8,0.3 -9,2.5 z",
    id: "path32-5",
    style: {
      fill: "#b93a97",
      fillOpacity: 1,
      strokeWidth: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 31.7,336.8 c -2.3,2.5 -2.1,5.8 0.3,8.2 1.8,1.8 3.1,2 8.7,1.8 5.9,-0.3 6.8,-0.6 8.7,-3.1 1.9,-2.6 1.9,-3 0.5,-5.5 -1.4,-2.5 -2,-2.7 -9,-3 -6.3,-0.2 -7.8,0 -9.2,1.6 z",
    id: "path34-3",
    style: {
      fill: "#b93a97",
      fillOpacity: 1,
      strokeWidth: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 75.8,336.1 c -1.2,0.6 -1.8,2.2 -1.8,4.4 0,5.4 2.6,6.5 14.7,6.5 9,0 10.6,-0.3 12.3,-2 2.5,-2.5 2.6,-6.2 0.2,-8.3 -1.5,-1.4 -4,-1.7 -12.8,-1.7 -6,0 -11.7,0.5 -12.6,1.1 z",
    id: "path36-5",
    style: {
      fill: "#b93a97",
      fillOpacity: 1,
      strokeWidth: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 130.7,336.8 c -2.4,2.6 -2.1,6.8 0.5,8.6 2,1.4 9.5,1.6 61.8,1.6 65.5,0 64,0.1 64,-5.9 0,-6.3 2.5,-6.1 -64.2,-6.1 -57.3,0 -60.6,0.1 -62.1,1.8 z",
    id: "path38-6",
    style: {
      fill: "#b93a97",
      fillOpacity: 1,
      strokeWidth: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 284.7,336.8 c -2.3,2.5 -2.1,5.8 0.3,8.2 1.7,1.7 3.3,2 12.4,2 11.7,0 14.9,-1.3 14.9,-6.3 0,-5.1 -1.5,-5.7 -14.3,-5.7 -10.1,0 -11.9,0.3 -13.3,1.8 z",
    id: "path40-0",
    style: {
      fill: "#b93a97",
      fillOpacity: 1,
      strokeWidth: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 336.6,337.2 c -2.2,3.1 -2,4.5 0.9,7.3 2,2.1 3.4,2.5 8.5,2.5 6.7,0 10,-2.1 10,-6.3 0,-4.2 -2.9,-5.7 -10.8,-5.7 -6.2,0 -7.3,0.3 -8.6,2.2 z",
    id: "path42-1",
    style: {
      fill: "#b93a97",
      fillOpacity: 1,
      strokeWidth: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 217.7,48.2 c -4.1,4.2 -58.9,94.9 -58.9,97.5 0,1.4 0.6,3.2 1.5,4 1.9,1.9 6.4,2 8.2,0.2 2.1,-2.1 58.1,-94.1 58.9,-96.6 0.5,-1.7 0.1,-2.9 -1.8,-4.8 -3.1,-3.1 -5,-3.2 -7.9,-0.3 z",
    id: "path44-7",
    style: {
      fill: "#b93a97",
      fillOpacity: 1,
      strokeWidth: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 256.2,47.6 c -1.5,1 -2.2,2.5 -2.2,4.7 0,2.8 2.5,5.7 21.7,24.9 l 21.8,21.8 -21.8,21.8 c -19,19 -21.7,22.1 -21.7,24.8 0,3.7 2,5.7 5.6,5.6 3.8,0 52.4,-48.5 52.4,-52.2 0,-2 -5.5,-8.1 -25.3,-27.8 C 272.8,57.4 260.7,46 259.9,46 c -0.8,0 -2.5,0.7 -3.7,1.6 z",
    id: "path46-2",
    style: {
      fill: "#b93a97",
      fillOpacity: 1,
      strokeWidth: 0.1
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevKeeb);
export default __webpack_public_path__ + "static/media/dev-keeb.6c34e3e3804bda1addd5b86c5b1bf295.svg";
export { ForwardRef as ReactComponent };